// All data here is SIMULATED for the ClearPath prototype.
// Nothing is persisted; nothing is transmitted.

export const USER = {
    name: "Maria",
};

export const TODAY_SUMMARY = {
    glucose: { value: 118, unit: "mg/dL", status: "In Range" },
    bp: { lastReadingAt: "9:14 AM today" },
    nextMedication: { name: "Metformin", time: "6:00 PM" },
    nextAppointment: {
        doctor: "Dr. Priya Patel",
        when: "Tomorrow, 10:30 AM",
    },
};

export const TRUSTED_CIRCLE = [
    {
        id: "jenny",
        name: "Jenny",
        relation: "Daughter",
        avatarSeed: "jenny",
    },
    {
        id: "tom",
        name: "Tom",
        relation: "Husband",
        avatarSeed: "tom",
    },
];

export const MEDICATIONS = [
    { id: "m1", name: "Metformin", dose: "500 mg", time: "8:00 AM", status: "taken" },
    { id: "m2", name: "Lisinopril", dose: "10 mg", time: "8:00 AM", status: "taken" },
    { id: "m3", name: "Atorvastatin", dose: "20 mg", time: "9:00 PM", status: "pending" },
];

export const APPOINTMENT = {
    doctor: "Dr. Priya Patel",
    specialty: "Primary Care",
    when: "Tomorrow, 10:30 AM",
    avatarSeed: "doctor",
    preVisit: [
        { id: "glucose-log", label: "Glucose log (7 days)", ready: true },
        { id: "bp-log", label: "Blood pressure log (7 days)", ready: true },
    ],
};

export const SHOPPING_CATEGORIES = [
    {
        id: "food",
        title: "Food Delivery",
        stores: [
            { id: "doordash", name: "DoorDash", logo: "https://logo.clearbit.com/doordash.com", tag: "food" },
            { id: "ubereats", name: "Uber Eats", logo: "https://logo.clearbit.com/ubereats.com", tag: "food" },
            { id: "grubhub", name: "Grubhub", logo: "https://logo.clearbit.com/grubhub.com", tag: "food" },
            { id: "postmates", name: "Postmates", logo: "https://logo.clearbit.com/postmates.com", tag: "food" },
        ],
    },
    {
        id: "grocery",
        title: "Groceries",
        stores: [
            { id: "instacart", name: "Instacart", logo: "https://logo.clearbit.com/instacart.com", tag: "grocery" },
            { id: "walmart", name: "Walmart Grocery", logo: "https://logo.clearbit.com/walmart.com", tag: "grocery" },
            { id: "amazonfresh", name: "Amazon Fresh", logo: "https://logo.clearbit.com/amazon.com", tag: "grocery" },
            { id: "wholefoods", name: "Whole Foods", logo: "https://logo.clearbit.com/wholefoodsmarket.com", tag: "grocery" },
        ],
    },
    {
        id: "stores",
        title: "Stores",
        stores: [
            { id: "amazon", name: "Amazon", logo: "https://logo.clearbit.com/amazon.com", tag: "store" },
            { id: "target", name: "Target", logo: "https://logo.clearbit.com/target.com", tag: "store" },
            { id: "etsy", name: "Etsy", logo: "https://logo.clearbit.com/etsy.com", tag: "store" },
            { id: "wayfair", name: "Wayfair", logo: "https://logo.clearbit.com/wayfair.com", tag: "store" },
            { id: "bestbuy", name: "Best Buy", logo: "https://logo.clearbit.com/bestbuy.com", tag: "store" },
            { id: "walgreens", name: "Walgreens", logo: "https://logo.clearbit.com/walgreens.com", tag: "store" },
        ],
    },
];

export const SAMPLE_STORE_RESULTS = {
    amazon: {
        kind: "products",
        items: [
            { id: "p1", name: "Crest 3D White Toothpaste, 4.1 oz", price: "$5.99", rating: 4.7, meta: "Prime · Tomorrow" },
            { id: "p2", name: "Crest Pro-Health Toothpaste Twin Pack", price: "$8.49", rating: 4.8, meta: "Prime · Tomorrow" },
            { id: "p3", name: "Sensodyne Pronamel Toothpaste", price: "$6.79", rating: 4.6, meta: "Prime · Today" },
        ],
    },
    doordash: {
        kind: "restaurants",
        items: [
            { id: "r1", name: "Domino's Pizza", price: "Delivery $0.99", rating: 4.5, meta: "25–35 min" },
            { id: "r2", name: "Olive Garden", price: "Delivery $2.99", rating: 4.6, meta: "30–40 min" },
            { id: "r3", name: "Panera Bread", price: "Delivery $1.99", rating: 4.7, meta: "20–30 min" },
        ],
    },
    instacart: {
        kind: "products",
        items: [
            { id: "i1", name: "Organic Bananas, 3 lb", price: "$2.49", rating: 4.8, meta: "Delivery 1 hr" },
            { id: "i2", name: "Honeycrisp Apples, 2 lb", price: "$5.99", rating: 4.7, meta: "Delivery 1 hr" },
            { id: "i3", name: "Whole Milk, 1 gal", price: "$3.79", rating: 4.9, meta: "Delivery 1 hr" },
        ],
    },
};

export const DEFAULT_STORE_RESULTS = {
    kind: "products",
    items: [
        { id: "d1", name: "Top Pick · Best seller", price: "$12.99", rating: 4.7, meta: "Fast delivery" },
        { id: "d2", name: "Customer favorite", price: "$9.49", rating: 4.6, meta: "Fast delivery" },
        { id: "d3", name: "Recommended for Maria", price: "$15.00", rating: 4.8, meta: "Fast delivery" },
    ],
};

export const TRANSPORT_OPTIONS = [
    { id: "doordash", name: "DoorDash", desc: "Food delivery", icon: "Utensils" },
    { id: "ubereats", name: "Uber Eats", desc: "Food delivery", icon: "Utensils" },
    { id: "uber", name: "Uber", desc: "Rideshare", icon: "Car" },
    { id: "lyft", name: "Lyft", desc: "Rideshare", icon: "Car" },
    { id: "transit", name: "Public Transit", desc: "Bus & subway", icon: "Bus" },
    { id: "paratransit", name: "Paratransit", desc: "Accessible transport", icon: "Accessibility" },
];

export const BILLS = [
    { id: "electric", name: "Electric", provider: "PG&E", amount: 124, due: "Due in 4 days" },
    { id: "internet", name: "Internet", provider: "Comcast Xfinity", amount: 89, due: "Due in 7 days" },
    { id: "phone", name: "Phone", provider: "Verizon Wireless", amount: 65, due: "Due in 9 days" },
    { id: "water", name: "Water", provider: "City Water Co.", amount: 42, due: "Due in 12 days" },
];

export const MESSAGES = [
    {
        id: "jenny",
        sender: "Jenny",
        senderTag: "Daughter",
        time: "2h",
        preview: "Mom, did you want me to come over Sunday?",
        full: "Hi Mom, did you want me to come over Sunday? I can bring lunch and we can go through those photo albums. Let me know what works for you. Love you.",
        avatarSeed: "jenny",
    },
    {
        id: "patel",
        sender: "Dr. Patel",
        senderTag: "Primary Care",
        time: "5h",
        preview: "Looking forward to our visit tomorrow…",
        full: "Hi Maria. Looking forward to our visit tomorrow at 10:30 AM. Please make sure your glucose and blood pressure logs are ready in the app. Have a restful evening.",
        avatarSeed: "doctor",
    },
    {
        id: "walgreens",
        sender: "Walgreens Pharmacy",
        senderTag: "Pharmacy",
        time: "1d",
        preview: "Your prescription is ready for pickup.",
        full: "Hi Maria, your prescription for Metformin is ready for pickup at the Walgreens on Maple Street. We are open until 9 PM today.",
        avatarSeed: "walgreens",
    },
    {
        id: "bookclub",
        sender: "Book Club",
        senderTag: "Group",
        time: "2d",
        preview: "Next meeting is Thursday at 7…",
        full: "Hi everyone, our next book club meeting is Thursday at 7 PM at Linda's house. We're discussing chapters 5 through 8. See you there.",
        avatarSeed: "bookclub",
    },
];

export const HOME_ACTIONS = [
    { id: "shopping", title: "Shopping", desc: "Order from any store", icon: "ShoppingBag" },
    { id: "transport", title: "Food & Rides", desc: "Delivery & rideshare", icon: "Car" },
    { id: "vitals", title: "Health Vitals", desc: "Glucose & blood pressure", icon: "HeartPulse" },
    { id: "telehealth", title: "Doctor Visits", desc: "Telehealth appointments", icon: "Stethoscope" },
    { id: "bills", title: "Pay Bills", desc: "Secure voice payments", icon: "Wallet" },
    { id: "messages", title: "Messages", desc: "Family & care team", icon: "MessageSquareHeart" },
];

export const HELP_TEXT = {
    home: "This is your home screen, Maria. Tap any card to go there. The big black button at the top opens voice commands. The red Emergency Help card calls your trusted contact in two taps. Below the cards you can see today's vitals and your family circle.",
    vitals: "This is Health Vitals. Your latest glucose and blood pressure readings are at the top. Tap Take New Reading to simulate a fresh blood pressure measurement. Scroll down to see a seven-day history chart and your medication schedule.",
    telehealth: "This is Doctor Visits. Your next appointment is shown at the top. Tap Join Appointment to start a video call with Doctor Patel. I'll walk you through camera and microphone checks first.",
    shopping: "This is Voice Shopping. You can tap any store, or tap Tell Clara Where to Shop to speak. I'll open the right store for you. Every product I show you is read aloud when you tap it.",
    transport: "This is Food and Rides. Tap any service to start an order or a trip. I'll narrate every step.",
    bills: "This is Pay Bills. You'll see your four bills with their amounts and due dates. Tap Pay on any bill to start a secure payment with your fingerprint.",
    messages: "This is Messages. Tap any message to open and hear it read aloud by me. The newest message is at the top.",
    caregiver: "This is your weekly summary for caregivers. It shows seven days of vitals, medication adherence, and your next appointment. Tap Copy share link to send a read-only view to your trusted contacts.",
};
